

<div fixedScroll [otherElements]="otherElements" [baseElement]="baseElement">
    <ss-process-review></ss-process-review>
</div>


